import { render } from "./opTable.vue?vue&type=template&id=e84a3a1a&ts=true"
import script from "./opTable.vue?vue&type=script&lang=ts"
export * from "./opTable.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__